import { Building2, ClipboardCheck, Wallet } from "lucide-react";
import { SETTLEMENT_DEFAULTS } from "../../lib/settlement";
import type { SettingsInput } from "../../lib/types";

export const STEPS = [
  { label: "Business", text: "Your business name", icon: Building2 },
  { label: "Payout", text: "Where payments settle", icon: Wallet },
  { label: "Review", text: "Check and create", icon: ClipboardCheck },
] as const;
/** The step after the last one: the profile exists. */
export const DONE = STEPS.length;

export type PayoutMethod = "own" | "unizpay";

/** The live payout wallet, as the wizard collects it. */
export interface PayoutDraft {
  /** Live networks are not enabled on this server: the payout is set later in Settings. */
  unavailable: boolean;
  method: PayoutMethod;
  network: string;
  networkName: string;
  token: string;
  /** Own wallet only. */
  address: string;
}

/** Everything the wizard collects; nothing is sent until the review step. */
export interface Draft {
  name: string;
  payout: PayoutDraft;
}

export const EMPTY_DRAFT: Draft = {
  name: "",
  payout: {
    unavailable: false,
    method: "own",
    network: "",
    networkName: "",
    token: "",
    address: "",
  },
};

/**
 * The live settlement to create with the profile, or none when payouts are set later. One payout
 * here; tokens received as they are and fallbacks are set in Settings › Payouts. The fallback
 * is the default (the UnizPay wallet).
 */
export function toSettlement(p: PayoutDraft): SettingsInput | null {
  if (p.unavailable) return null;
  const own = p.method === "own";
  return {
    mode: "live",
    payouts: [
      own
        ? { network: p.network, token: p.token, to: "external", address: p.address.trim() }
        : { network: p.network, token: p.token, to: "wallet" },
    ],
    fallbacks: {},
    ...SETTLEMENT_DEFAULTS,
  };
}
